
import './Toggle.css'

const Toggle = ({isChecked,HandleToggle}) => {


  return (
    <div>
        <div className={`Toggle ${isChecked?'checked':""}`} onClick={HandleToggle}>
          <div className='ToggleBase'></div>
          <div className='ToggleBall'></div>
        </div>
    </div>
  )
}

export default Toggle